// Espelha AcaoAutomacaoVendaEnum da API.Vendas: a ação de automação que a API.Vendas decide no salvar ou no mover e o
// orquestrador executa (D16).
export enum AcaoAutomacaoVendaEnum {
    ReservaEstoque = 1,
    LiberacaoReservaEstoque = 2,
    ConversaoReservaEstoque = 3,
    SaidaEstoque = 4,
}
